// mui 5
import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";



export const StyledIconButton = styled(IconButton)(({ theme }) => ({
  transition: "transform .4s ease",
  cursor: "pointer",
  color: "#fff",
  ":hover": {
    transform: "scale(1.2,1.2)",
    color: theme.palette.primary.light,
  },
}));


export const StyledCardActions = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "center",
  // marginTop: theme.spacing(2)
}));